<template>
  <div id="page" :style="{ backgroundImage: 'url(' + this.url + ' )' }">
    <img
      :src="images.top"
      style="width: 100%; float: center; margin-top: 40px"
    />
    <div style="width: 100%; height: 40px; background-color: white"></div>
    <div
      style="
        width: 100%;
        height: 36px;
        background-color: white;
        margin-top: 935px;
      "
    ></div>

    <div id="footer">
      <span v-if="page < 10" id="footer-red">{{ page }}</span>
      <span v-else id="footer-red">{{ page }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["model", "url", "page"],
  data() {
    return {
      images: {
        top: require("@/views/CNBM/images/top.png"),
        youshi: require("@/views/CNBM/images/youshi.png"),
        huojian: require("@/views/CNBM/images/huojian.png"),
      },
    };
  },
  mounted() {
    if (this.model) {
    }
  },
  watch: {},
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/views/CNBMTalent/pages/page-five.vue